<script setup>
import { computed, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore, useMapGetter } from 'dashboard/composables/store';

import Banner from 'dashboard/components-next/banner/Banner.vue';

const props = defineProps({
  contactId: { type: Number, default: 0 },
});

const { t } = useI18n();
const store = useStore();

const groupGetter = useMapGetter('contactGroups/getGroup');

const group = computed(() => groupGetter.value(props.contactId));
const isAnnouncementOnly = computed(
  () => group.value?.metadata?.announcement_only === true
);
const hasLeft = computed(() => group.value?.sendable === false);

watch(
  () => props.contactId,
  contactId => {
    if (contactId) store.dispatch('contactGroups/show', { contactId });
  },
  { immediate: true }
);
</script>

<template>
  <div class="flex flex-col gap-2">
    <Banner v-if="isAnnouncementOnly" color="amber">
      {{ t('GROUPS.BANNER.ANNOUNCEMENT_ONLY') }}
    </Banner>
    <Banner v-if="hasLeft" color="ruby">
      {{ t('GROUPS.BANNER.LEFT') }}
    </Banner>
  </div>
</template>
